import { ColorProps } from '../utils/UNSAFE_interpolations/colors';
import { Dimension } from './PlotArea.types';

export function getAxisLineProps(
  availSpace: Dimension,
  axisPosition: 'left' | 'right' | 'top' | 'bottom',
  axisLine?: {
    lineColor?: ColorProps['color'];
    lineWidth?: number;
    isRendered: boolean;
  }
) {
  return {
    x1: axisPosition === 'right' ? availSpace.x + availSpace.width : availSpace.x,
    x2: axisPosition === 'left' ? availSpace.x : availSpace.x + availSpace.width,
    y1: axisPosition === 'bottom' ? availSpace.y + availSpace.height : availSpace.y,
    y2: axisPosition === 'top' ? availSpace.y : availSpace.y + availSpace.height,
    stroke: axisLine?.lineColor,
    strokeWidth: axisLine?.lineWidth
  };
}

export function getBaseLineProps(
  availSpace: Dimension,
  coord: number,
  axisPosition: 'left' | 'right' | 'top' | 'bottom'
) {
  let x1, x2, y1, y2: number;
  if (axisPosition === 'bottom') {
    x1 = availSpace.x;
    x2 = availSpace.x + availSpace.width;
    y1 = coord;
    y2 = coord;
  } else {
    x1 = coord;
    x2 = coord;
    y1 = availSpace.y;
    y2 = availSpace.y + availSpace.width;
  }

  return { x1, x2, y1, y2 };
}
